import React from "react";
import { FaCheckCircle, FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { TbDatabaseDollar } from "react-icons/tb";
import { SettingGeneralProvider } from "../../../context/settingGeneralContext";
import TableReusable from "../../Global/Table";

export default function TableFee({
  getData,
  page,
  formatToRupiah,
  rows,
  pages,
  changePage,
  msg,
  viewModalUpdate,
  viewModalPaymentType,
  deleteById,
  isTabletOrMobile
}) {
  return (
    <SettingGeneralProvider>
      <TableFeeContent
        getData={getData}
        formatToRupiah={formatToRupiah}
        rows={rows}
        page={page}
        pages={pages}
        changePage={changePage}
        msg={msg}
        viewModalUpdate={viewModalUpdate}
        viewModalPaymentType={viewModalPaymentType}
        deleteById={deleteById}
      />
    </SettingGeneralProvider>
  )
}

function TableFeeContent({
  getData,
  rows,
  page,
  pages,
  changePage,
  msg,
  formatToRupiah,
  viewModalUpdate,
  viewModalPaymentType,
  deleteById,
}) {

  const getRowNumber = (index) => (page - 1) * 10 + index + 1;

  return (
    <>
      <div style={{ display: "block", height: "100%", overflowY: "auto", overflowX: "auto" }}>
        <TableReusable
          columns={[
            { key: "no", label: "No", render: (_, index) => getRowNumber(index) },
            { key: "name", label: "Nama Fee", render: (row) => `${row.name}` },
            { key: "payment_type_name", label: "Tipe Fee", render: (row) => `${row.payment_type_name}` },
            { key: "price_type", label: "Biaya Fee", render: (row) => `${formatToRupiah(row.price)}` },
            {
              key: "action",
              label: "Setup",
              render: (user) => (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                  <button
                    onClick={() => viewModalPaymentType(user?.id, user?.name, user?.price, user?.id_payment_type)}
                    style={{
                      fontSize: "13px",
                      color: "white",
                      backgroundColor: "#3d64ff",
                      padding: "5px 5px",
                      borderRadius: "3px",
                      cursor: "pointer",
                      border: "none",
                      display: "flex",
                      marginRight: "3px",
                    }}
                  >
                    <TbDatabaseDollar />
                  </button>
                  <button
                    onClick={() => viewModalUpdate(user?.id, user?.name, user?.price, user?.id_payment_type)}
                    style={{
                      fontSize: "12px",
                      color: "white",
                      backgroundColor: "#ff9933",
                      padding: "5px 5px",
                      borderRadius: "3px",
                      cursor: "pointer",
                      border: "none",
                      display: "flex"
                    }}>
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => deleteById(user?.id)}
                    style={{
                      fontSize: "12px",
                      color: "white",
                      backgroundColor: "#B60000",
                      padding: "5px 5px",
                      borderRadius: "3px",
                      cursor: "pointer",
                      border: "none",
                      display: "flex"
                    }}>
                    <FaTrash />
                  </button>
                </div>
              ),
            },
          ]}
          data={getData}
          rows={rows}
          page={page}
          pages={pages}
          changePage={changePage}
          msg={msg}
        />
      </div >
    </>
  )

}